// extracted by mini-css-extract-plugin
export default {"card3":"Pih6qS36","altheadline":"Wq1JE_FM","link":"QUieMngm","info":"_I0wYzqX"};